import { AvailableReadProviders, EEthereumNetworkId } from '@ankr.com/provider';

export const ChainsAvailableReadProvider: {
  [key in EEthereumNetworkId]?: AvailableReadProviders;
} = {
  [EEthereumNetworkId.mainnet]: AvailableReadProviders.ethMainnet,
  [EEthereumNetworkId.goerli]: AvailableReadProviders.ethGoerli,
  [EEthereumNetworkId.mumbai]: AvailableReadProviders.mumbai,
  [EEthereumNetworkId.polygon]: AvailableReadProviders.polygon,
  [EEthereumNetworkId.smartchain]: AvailableReadProviders.binanceChain,
  [EEthereumNetworkId.smartchainTestnet]:
    AvailableReadProviders.binanceChainTest,
};

const BASE_PROD_BFF_URL = 'https://bff.staking.ankr.com';
const BASE_DEV_BFF_URL = 'https://bff.dev.staking.ankr.com';

const BFF_BY_ENV_URL =
  process.env.REACT_APP_ENV === 'prod' ? BASE_PROD_BFF_URL : BASE_DEV_BFF_URL;

const BFF_MRPC_URL = `${BFF_BY_ENV_URL}/multi-rpc/proxy`;

export const CUSTOM_RPC_URLS: Partial<Record<AvailableReadProviders, string>> =
  {
    [AvailableReadProviders.ethMainnet]: `${BFF_MRPC_URL}/eth`,
    [AvailableReadProviders.ethGoerli]: `${BFF_MRPC_URL}/eth_goerli`,
    [AvailableReadProviders.ethSepolia]: `${BFF_MRPC_URL}/eth_sepolia`,
    [AvailableReadProviders.avalancheChain]: `${BFF_MRPC_URL}/avalanche`,
    [AvailableReadProviders.avalancheChainTest]: `${BFF_MRPC_URL}/avalanche_fuji`,
    [AvailableReadProviders.binanceChain]: `${BFF_MRPC_URL}/bsc`,
    [AvailableReadProviders.binanceChainTest]: `${BFF_MRPC_URL}/bsc_testnet_chapel`,
    [AvailableReadProviders.ftmOpera]: `${BFF_MRPC_URL}/fantom`,
    [AvailableReadProviders.ftmTestnet]: `${BFF_MRPC_URL}/fantom_testnet`,
    [AvailableReadProviders.mumbai]: `${BFF_MRPC_URL}/polygon_mumbai`,
    [AvailableReadProviders.polygon]: `${BFF_MRPC_URL}/polygon`,
    [AvailableReadProviders.gnosis]: `${BFF_MRPC_URL}/gnosis`,
    [AvailableReadProviders.chiado]: 'https://rpc.chiadochain.net',
    [AvailableReadProviders.xdc]: 'https://erpc.xinfin.network',
    [AvailableReadProviders.xdcTestnet]: 'https://erpc.apothem.network',
  };
